import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "justify-content-center d-flex position-absolute w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!

  return (_openBlock(), _createBlock(_component_b_progress, { class: "position-relative" }, {
    default: _withCtx(() => [
      _createVNode(_component_b_progress_bar, {
        max: _ctx.parts.max,
        value: _ctx.parts.confirmed,
        class: _normalizeClass(["progress-bar-striped", 'requisite-fill-confirmed--' + _ctx.barStatus])
      }, null, 8, ["max", "value", "class"]),
      _createVNode(_component_b_progress_bar, {
        max: _ctx.parts.max,
        value: _ctx.parts.frozen,
        class: "progress-bar-striped requisite-fill-frozen"
      }, null, 8, ["max", "value"]),
      _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.total)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.limit)), 1)
    ]),
    _: 1
  }))
}